import Scriba from 'react-scriba';

export class DataCommercialisateur {


    //static _onChargementMandatCommercialisateurSelectionne(loginCompte, idOperation, idLotCommercial) {
    //    let objet = {
    //        "loginCompte": loginCompte,
    //        "idOperation": idOperation,
    //        "idLotCommercial": idLotCommercial
    //    };

    //    var url = "api/Fiche/GetMandatCommercialisateurLePlusBasPourUnLotCommercial";
    //    var paramPost = Scriba.fetch().createParameterPost(objet);

    //    return fetch(url, paramPost).then(response => response.json());
    //}

    //static _chargementLotCommercial(idOperation, idLotCommercial) {
    //    let objet = {
    //        "idOperation": idOperation,
    //        "idLotCommercial": idLotCommercial
    //    };

    //    var url = "api/Get/GetLotCommercial";
    //    var paramPost = Scriba.fetch().createParameterPost(objet);

    //    return fetch(url, paramPost).then(response => response.json());
    //}

    static _chargementCommercialisateurTemporaire(loginCompte, honoraireReelNombre, honoraireReelPourcentage, idMandat) {
        let objet = {};

        if (idMandat !== undefined) {
            objet = {
                "loginCompte": loginCompte,
                "idMandat": idMandat,
                "honoraireReelNombre": honoraireReelNombre,
                "honoraireReelPourcentage": honoraireReelPourcentage
            };
        }
        else {
            objet = {
                "loginCompte": loginCompte,
                "honoraireReelNombre": honoraireReelNombre,
                "honoraireReelPourcentage": honoraireReelPourcentage
            };
        }

        var url = "api/Get/GetCommercialisateurTemporaire";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

}